<p class="notice-panel" [ngClass]="{ margin: margin() }">
    <span>
        <mat-icon aria-label="Info" role="button" tabindex="0" [attr.aria-hidden]="false" [svgIcon]="icon()" />
    </span>
    <span>
        <ng-content />
    </span>
</p>
